var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M5 2.5C3.6171875 2.5 2.5 3.6171875 2.5 5L2.5 8.1171875L17.78125 19.320312C19.101562 20.289062 20.898438 20.289062 22.21875 19.320312L37.5 8.1171875L37.5 5C37.5 3.6171875 36.382812 2.5 35 2.5L5 2.5ZM2.5 11.21875L2.5 25C2.5 26.382812 3.6171875 27.5 5 27.5L35 27.5C36.382812 27.5 37.5 26.382812 37.5 25L37.5 11.21875L23.695312 21.335938C21.492188 22.945312 18.5 22.945312 16.304688 21.335938L2.5 11.21875ZM0 5C0 2.2421875 2.2421875 0 5 0L35 0C37.757812 0 40 2.2421875 40 5L40 25C40 27.757812 37.757812 30 35 30L5 30C2.2421875 30 0 27.757812 0 25L0 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmailIcon);
export default __webpack_public_path__ + "static/media/newEmailIcon.7ddae0da75b4c0405a68b1e13bd94bb1.svg";
export { ForwardRef as ReactComponent };